export function getServerInfo(route) {
  // En producción, usar la configuración normal
  if (process.env.REACT_APP_IS_DEVELOPMENT !== 'true') {
    const serverHostname = window.location.hostname
    const displayPort =
      window.location.port || (window.location.protocol === 'https:' ? '443' : '80')
    return `${window.location.protocol}//${serverHostname}:${displayPort}/${route}/`
  }

  // Si usamos servidor local en desarrollo
  if (process.env.REACT_APP_IS_USE_LOCAL === 'true') {
    const proxies = {
      api: 'http://10.1.170.8:3333/',
      ws: 'http://10.1.170.8:2020/',
      blob: 'http://10.1.170.8:9090/blob/',
    }
    return `${proxies[route]}`
  }

  // Proxy de desarrollo por defecto
  const developmentProxy = process.env.REACT_APP_DEVELOPMENT_PROXY
  return `${developmentProxy}/${route}/`
}
